import React from 'react';
import OtherPostCard from './OtherPostCard';

function OtherPosts({ targetUrl, posts, selectedSupportingArticles = [], toggleSupportingArticle, remainingPosts, setRemainingPosts }) {
  return (
    <div className="flex flex-col gap-4 max-h-[calc(100vh-8rem)] overflow-auto">
      {posts.map((post) => (
        <OtherPostCard
          key={post.url}
          targetUrl={targetUrl}
          post={post}
          isSelected={selectedSupportingArticles.includes(post.url)}
          toggleSupportingArticle={toggleSupportingArticle}
          remainingPosts={remainingPosts}
          setRemainingPosts={setRemainingPosts}
        />
      ))}
    </div>
  );
}

export default OtherPosts;
